import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import { getMajorations as onGetMajoration } from "../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";

const Majoration = (props) => {
  const [loading, setLoading] = useState(true);

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  const history = useHistory();
  const [formData1, setFormData1] = useState({});
  const dispatch = useDispatch();
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;

  const [majorationList, setMajorationList] = useState([]);
  const fetchMajorationList = async () => {
    try {
      const majoration_list = await axiosInstance.get(
        `/majorationbytypeengin/`
      );

      if (majoration_list?.data) {
        console.log("majoration_list?.data: ", majoration_list?.data);
        setMajorationList(majoration_list.data.majoration);
      }
      console.log(
        "Liste majoration fetchMajorationList: ",
        majoration_list.data.majoration
      );
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    try {
      fetchMajorationList();
    } catch (error) {
      console.error("Erreur de fetch majoration: ", error);
    }
    // finally {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 2000);
    // }
  }, []);

  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const [factureGenerate, setMajorationGenerate] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [columnMajorationSelected, setColumnMajorationSelected] = useState({
    column: null,
    columnName: null,
    value: null,
    id: null,
  });

  //delete Conatct
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalMotif, setModalMotif] = useState(false);

  const handleClickViewMotif = (etat, motifs) => {
    if (etat === "Desactiver" && motifs != null) {
      alert(motifs);
    }
  };

  // Add Data
  const handleMajorationClicks = () => {
    setColumnMajorationSelected({
      column: null,
      columnName: null,
      value: null,
      id: null,
    });

    setIsEdit(false);
    // toggle();
  };

  const dateFormat = () => {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
  };

  const timeFormat = () => {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? (hours = "0" + hours) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  // Update Data
  const handleMajorationClick = useCallback((arg) => {
    const facture = arg;
    // console.log("handleMajorationClick: ", arg);
    setColumnMajorationSelected({
      column: arg.column,
      columnName: arg.columnName,
      value: arg.value,
      id: arg.id,
    });

    // toggle();
  }, []);

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="factureCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },

      {
        Header: props.t("Type majoration"),
        accessor: "type_majoration",
        filterable: false,
      },
      {
        Header: props.t("Pourcentage"),
        accessor: "pourcentage",
        filterable: false,
        Cell: (cell) => (
          <>
            <li className="list-inline-item" title={props.t("Modifier")}>
              {cell.row.original.pourcentage} {" %"}
              <Link
                to="#"
                className="text-warning d-inline-block"
                onClick={() => {
                  const majorationData = cell.row.original;
                  handleMajorationClick({
                    column: majorationData.type_majoration,
                    columnName: "pourcentage",
                    value: majorationData.pourcentage,
                    id: majorationData.id,
                  });
                  setIsEdit(true);
                  setModal(true);
                  // toggle();
                }}
              >
                <i className="ri-pencil-fill align-middle"></i>
              </Link>
            </li>
          </>
        ),
      },
      {
        Header: props.t("Engin"),
        accessor: "designation",
        filterable: false,
        Cell: (cell) => (
          <>
            <li
              className={`list-inline-item`}
              title={props.t(
                `${cell.row.original.designation || ""} ${
                  cell.row.original.classe || ""
                }`
              )}
            >
              {cell.row.original.designation
                ? `${cell.row.original.designation || ""} ${
                    cell.row.original.classe || ""
                  }`
                : "Tous"}
              {cell.row.original.designation} {cell.row.original.classe}
            </li>
          </>
        ),
      },
    ],
    [handleMajorationClick, props]
    // [setInfo, handleMajorationClick, toggle, props, handlerefuse, handleaccept]
  );

  const SUPPORTED_FORMATS = ["image/*"];
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      value_column: columnMajorationSelected.value || "",
    },
    validationSchema: Yup.object({
      value_column: Yup.number()
        .min(0, "Le pourcentage de majoration ne peut pas être inférieur à 0")
        .max(
          100,
          "Le pourcentage de majoration ne peut pas être supérieur à 100"
        )
        .required(props.t("Veuillez renseigner le pourcentage de majoration")),
    }),
    onSubmit: async (values) => {
      // console.log("Values: ", values);

      const instanceMajoration = {
        id_typeengin: columnMajorationSelected.id,
        pourcentage: parseFloat(values.value_column),
      };
      console.log("instanceMajoration: ", instanceMajoration);

      if (isEdit) {
        try {
          const data = axiosInstance
            .put(`/updatepourcentage/`, instanceMajoration)
            .then(async (response) => {
              // dispatch(onUpdateMajoration(updateMajoration));
              validation.resetForm();
              toast.success(
                props.t(
                  `Le pourcentage de la majoration ${columnMajorationSelected.column} a été modifié avec succès`
                ),
                {
                  autoClose: 3000,
                }
              );
              await fetchMajorationList();
            })
            .catch((error) => {
              toast.error(
                props.t(
                  `Echec de la modification du ${columnMajorationSelected.column}`
                ),
                {
                  autoClose: 3000,
                }
              );
            });

          // window.location.reload(true);
        } catch (err) {
          console.error(err);
          toast.error(
            props.t(
              `Echec de la modification du ${columnMajorationSelected.column}`
            ),
            {
              autoClose: 2000,
            }
          );
        }
        await fetchMajorationList();
        setIsEdit(false);
      }

      setModal(false);
      setColumnMajorationSelected({});
      // toggle();
    },
  });

  // SideBar Majoration Detail

  document.title = props.t("Gestionnaire des majorations | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Gestionnaire des majorations")}
            pageTitle="Takci"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      {majorationList.length > 0 && (
                        <button
                          disabled={majorationList.length < 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="factureList">
                <CardBody className="pt-0">
                  <div>
                    {!loading ? (
                      majorationList.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={isExportCSV}
                            onCloseClick={() => setIsExportCSV(false)}
                            data={
                              majorationList.length > 0 ? majorationList : []
                            }
                          />

                          <TableContainer
                            columns={columns}
                            data={
                              majorationList.length > 0 ? majorationList : []
                            }
                            isGlobalFilter={true}
                            isAddUserList={false}
                            customPageSize={8}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleMajorationClick={handleMajorationClicks}
                          />
                        </>
                      ) : (
                        <h2 className="text-center my-3">
                          Aucune majoration disponible
                        </h2>
                      )
                    ) : (
                      <div className="text-center my-3">
                        <Loader style={{ color: "#014c94" }} />
                        <h2>Chargement...</h2>
                      </div>
                    )}
                  </div>

                  <Modal
                    id="showModal"
                    style={{ maxWidth: 800 }}
                    isOpen={modal}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      {/* { isEdit === true ? props.t( "Modifier Majoration" ) : props.t( "Ajouter Code Promo" ) } */}
                      {isEdit
                        ? props.t(
                            `Modifier la majoration ${columnMajorationSelected.column}`
                          )
                        : props.t("Ajouter la majoration")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        console.log("Submit...");
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div>
                              <Label
                                htmlFor="value_column"
                                className="form-label"
                              >
                                {props.t(
                                  `${
                                    columnMajorationSelected.column
                                      ? "Pourcentage de " +
                                        columnMajorationSelected.column
                                      : "La nouvelle valeur"
                                  }`
                                )}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="value_column"
                                id="value_column"
                                className="form-control"
                                placeholder={props.t(
                                  `Entrez ${
                                    columnMajorationSelected.column
                                      ? "Le " + columnMajorationSelected.column
                                      : "la nouvelle valeur"
                                  }`
                                )}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.value_column || ""}
                                invalid={
                                  validation.touched.value_column &&
                                  validation.errors.value_column
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.value_column &&
                              validation.errors.value_column ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.value_column}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={() => {
                              setModal(false);
                              fetchMajorationList();
                            }}
                            className="btn-light"
                          >
                            {props.t("Fermer")}
                          </Button>

                          <Button
                            type="submit"
                            className="btn"
                            style={{ background: "#002437", color: "white" }}
                            id="add-btn"
                            // onClick=()=>validation.
                          >
                            {isEdit
                              ? props.t(
                                  `Modifier le ${columnMajorationSelected.column}`
                                )
                              : props.t("Ajouter Majoration")}
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <ToastContainer closeButton={false} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Majoration.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Majoration));
